import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'spark-core-dx/components';

const MarketplaceDomain = ({ children }) => {
  return (
    <Layout layoutOverride="standard">
      {children ?? <Outlet />}
    </Layout>
  );
};

export default MarketplaceDomain;
